import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { servicesCards, images, companyInfo } from '../data/mock';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';
import { Globe, Clock, Shield, BarChart3, FileText, Users } from 'lucide-react';

const SponsorsPage = () => {
  const services = [
    { icon: Globe, title: 'Global Reach', desc: 'Diverse patient populations', id: 'global' },
    { icon: Clock, title: 'Efficient', desc: 'Fast study initiation', id: 'efficient' },
    { icon: Shield, title: 'Quality', desc: 'GCP standards compliance', id: 'quality' },
    { icon: BarChart3, title: 'Data Excellence', desc: 'High-quality collection', id: 'data' },
    { icon: FileText, title: 'Regulatory', desc: 'Submission support', id: 'regulatory' },
    { icon: Users, title: 'Expert Teams', desc: 'Experienced investigators', id: 'teams' }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      {/* Hero - Compact */}
      <section className="pt-8 pb-12 relative overflow-hidden">
        <div className="absolute inset-0">
          <img src={images.science} alt="Sponsors" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0a1628]/95 via-[#0a1628]/80 to-[#0a1628]/60" />
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 py-12">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-3">For <span className="text-[#87CEEB]">Sponsors</span></h1>
          <p className="text-lg text-white/80 mb-6 max-w-2xl">{servicesCards[1].description}</p>
          <Link to="/contact"><Button className="bg-[#1877F2] text-white px-6 py-4 rounded-full font-semibold">Partner With Us</Button></Link>
        </div>
      </section>

      {/* Services - Compact */}
      <section className="py-10 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl font-bold text-center text-gray-900 mb-8">Our <span className="text-[#1877F2]">Services</span></h2>
          <div className="grid md:grid-cols-3 lg:grid-cols-6 gap-4">
            {services.map((s) => (
              <Card key={s.id} className="border-0 shadow-md text-center p-4 rounded-xl">
                <div className="w-10 h-10 bg-gradient-to-br from-[#1877F2] to-[#87CEEB] rounded-lg flex items-center justify-center mx-auto mb-2">
                  <s.icon className="w-5 h-5 text-white" />
                </div>
                <h3 className="font-bold text-gray-900 text-sm">{s.title}</h3>
                <p className="text-gray-600 text-xs">{s.desc}</p>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* CTA - Compact */}
      <section className="py-10 bg-gradient-to-r from-[#1877F2] to-[#0a1628]">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-2xl font-bold text-white mb-3">Why Partner With Us?</h2>
          <p className="text-white/80 mb-6">Reliable services transforming scientific discoveries into patient treatments.</p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/contact"><Button className="bg-white text-[#1877F2] px-8 py-4 rounded-full font-bold">Contact Us</Button></Link>
            <a href={`tel:${companyInfo.contact.phone}`}><Button variant="outline" className="border-white text-white px-8 py-4 rounded-full font-bold">Call {companyInfo.contact.phone}</Button></a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default SponsorsPage;
